const keys = {
  USER: 'USER',
  TOKEN: 'TOKEN'
}

export default {
  /**
   * Get user.
   * @returns {object} user
  */
  getUser () {
    if (!localStorage) return false
    return localStorage.getItem(keys.USER)
  },

  /**
   * Get saved user.
   * @returns {string} token
  */
  getToken () {
    if (!localStorage) return false
    return localStorage.getItem(keys.TOKEN)
  },

  /**
   * Saving token.
   * @param {string} token
  */
  setToken (token) {
    if (!localStorage) return false
    localStorage.setItem(keys.TOKEN, token)
  },

  /**
   * Saving user.
   * @param {object} user
  */
  setUser (user) {
    if (!localStorage) return false
    localStorage.setItem(keys.USER, user)
  },

  cleanAll () {
    localStorage.clear()
  }
}
